import DateCell from './DateCell';

export default DateCell;
